import React from 'react'

import { Col, Form } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const MonedaFormGroup = ({ setMoneda, moneda }) => {
  const [monedasOptions, setMonedasOptions] = React.useState([])

  React.useEffect(() => {
    setMonedasOptions(
      MonedasConstant.__arrayAuxiliar.map((x, k) => (
        <option key={k} value={x.id}>
          {x.nombre}
        </option>
      ))
    )
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MONEDA' md={2} alignRightAt='md' />
      <Col md={10}>
        <Form.Select id='select-moneda' value={moneda} onChange={setMoneda}>
          {monedasOptions}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
